import { render } from "./MyEducation.vue?vue&type=template&id=6b6fbb22"
import script from "./MyEducation.vue?vue&type=script&lang=js"
export * from "./MyEducation.vue?vue&type=script&lang=js"

import "./MyEducation.vue?vue&type=style&index=0&id=6b6fbb22&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__